import { render, staticRenderFns } from "./ContentBlockEmbed.vue?vue&type=template&id=5b5c0703&"
import script from "./ContentBlockEmbed.vue?vue&type=script&lang=js&"
export * from "./ContentBlockEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports